// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"proReportChart_wrapper__3be84","blueBox":"proReportChart_blueBox__1_T1E"};